/** Every Monaco editor and the static code blocks that stand in for one share these font settings. */
export const EDITOR_FONT = {
    fontFamily: "'Fira Code', monospace",
    fontSize: 16,
    lineHeight: 22
} as const
